/**
 * @generated SignedSource<<d58c481e5cfc88843aa9649db63b4eaf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type sourcesPage_OnboardMutation$variables = {
  confirmRetractCount?: number | null | undefined;
  importStartOn?: string | null | undefined;
};
export type sourcesPage_OnboardMutation$data = {
  readonly qboSyncStart: {
    readonly enqueued: boolean;
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly retractCount: number | null | undefined;
  } | null | undefined;
};
export type sourcesPage_OnboardMutation = {
  response: sourcesPage_OnboardMutation$data;
  variables: sourcesPage_OnboardMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "confirmRetractCount"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "importStartOn"
},
v2 = [
  {
    "kind": "Variable",
    "name": "confirmRetractCount",
    "variableName": "confirmRetractCount"
  },
  {
    "kind": "Variable",
    "name": "importStartOn",
    "variableName": "importStartOn"
  },
  {
    "kind": "Literal",
    "name": "mode",
    "value": "onboard"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enqueued",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "retractCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "sourcesPage_OnboardMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "QboSyncStartMutationPayload",
        "kind": "LinkedField",
        "name": "qboSyncStart",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "sourcesPage_OnboardMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "QboSyncStartMutationPayload",
        "kind": "LinkedField",
        "name": "qboSyncStart",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8b4868d132510f76d3bb4891f94450f3",
    "id": null,
    "metadata": {},
    "name": "sourcesPage_OnboardMutation",
    "operationKind": "mutation",
    "text": "mutation sourcesPage_OnboardMutation(\n  $importStartOn: String\n  $confirmRetractCount: Int\n) {\n  qboSyncStart(mode: \"onboard\", importStartOn: $importStartOn, confirmRetractCount: $confirmRetractCount) {\n    enqueued\n    retractCount\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "01fe9564ecc8d95aa57f831f55b8dc1d";

export default node;
